import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { authGuard } from './guards/auth.guard';
import { hasPermissionGuard } from './guards/has-permission.guard';

const routes: Routes = [
  {
    path: '403', component: UnauthorizedComponent
  },
  {
    path: '404', component: PageNotFoundComponent
  },

  {
    path: 'pub',
    loadChildren: () => import('./pages/modules/authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: '', component: HomeComponent,
    canActivate: [authGuard], 
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule),
        canActivate: [hasPermissionGuard]
      },
      {
        path: 'profile',
        loadChildren: () => import('./pages//modules/profile/profile.module').then(m => m.ProfileModule),
        canActivate: [hasPermissionGuard]
      },
      {
        path: 'tk',
        loadChildren: () => import('./pages//modules/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [hasPermissionGuard]
      },     
     
      {
        path: 'clb-mng',
        loadChildren: () => import('./pages/modules/user-clblhl/user-clblhl.module').then(m => m.UserClblhlModule),
        canActivate: [hasPermissionGuard]
      },
      {
        path: 'khoi-mng',
        loadChildren: () => import('./pages/modules/user-clblhl-khoi/user-clblhl-khoi.module').then(m => m.UserClblhlKhoiModule),
        canActivate: [hasPermissionGuard]
      },
      {
        path: 'lop-mng',
        loadChildren: () => import('./pages/modules/user-clblhl-lop/user-clblhl-lop.module').then(m => m.UserClblhlLopModule),
        canActivate: [hasPermissionGuard]
      },
        {
        path: 'dt-mng',
        loadChildren: () => import('./pages/modules/user-clblhl-dt/user-clblhl-dt.module').then(m => m.UserClblhlDtModule),
        canActivate: [hasPermissionGuard]
      },
      {
        path: 'khoa-sinh',
        loadChildren: () => import('./pages/modules/khoa-sinh/khoa-sinh.module').then(m => m.KhoaSinhModule),
        canActivate: [hasPermissionGuard]
      },
      {
        path: 'bqc-bcn',
        loadChildren: () => import('./pages/modules/bqc-bcn-khoi-lop/bqc-bcn-khoi-lop.module').then(m => m.BqcBcnKhoiLopModule),
        canActivate: [hasPermissionGuard]
      },
      {
        path: 'bt',
        loadChildren: () => import('./pages/modules/bai-tap-rldd/bai-tap-rldd.module').then(m => m.BaiTapRlddModule),
        canActivate: [hasPermissionGuard]
      },
      {
        path: 'bt-khoi',
        loadChildren: () => import('./pages/modules/bai-tap-rldd-khoi/bai-tap-rldd-khoi.module').then(m => m.BaiTapRlddKhoiModule),
        canActivate: [hasPermissionGuard]
      },
      {
        path: 'bt-lop',
        loadChildren: () => import('./pages/modules/bai-tap-rldd-lop/bai-tap-rldd-lop.module').then(m => m.BaiTapRlddLopModule),
        canActivate: [hasPermissionGuard]
      },
      {
        path: 'bt-dt',
        loadChildren: () => import('./pages/modules/bai-tap-rldd-dt/bai-tap-rldd-dt.module').then(m => m.BaiTapRlddDtModule),
        canActivate: [hasPermissionGuard]
      } ,
      {
        path: 'k-l-mng',
        loadChildren: () => import('./pages/modules/khoi-lop/khoi-lop.module').then(m => m.KhoiLopModule),
        canActivate: [hasPermissionGuard]
      },
      {
        path: 'sp-clb',
        loadChildren: () => import('./pages/modules/support-clb/support-clb.module').then(m => m.SupportClbModule),
        canActivate: [hasPermissionGuard]
      } ,
      {
        path: 'sp-k',
        loadChildren: () => import('./pages/modules/support-khoi/support-khoi.module').then(m => m.SupportKhoiModule),
        canActivate: [hasPermissionGuard]
      },
      {
        path: 'sp-l',
        loadChildren: () => import('./pages/modules/support-lop/support-lop.module').then(m => m.SupportLopModule),
        canActivate: [hasPermissionGuard]
      },
      {
        path: 'sp-dt',
        loadChildren: () => import('./pages/modules/support-dt/support-dt.module').then(m => m.SupportDtModule),
        canActivate: [hasPermissionGuard]
      },
      {
        path: 'bpt-bcn-k',
        loadChildren: () => import('./pages/modules/bpt-khoi-bcn-lop-for-khoi/bpt-khoi-bcn-lop-for-khoi.module').then(m => m.BptKhoiBcnLopForKhoiModule),
        canActivate: [hasPermissionGuard]
      },
       {
        path: 'bcn-l',
        loadChildren: () => import('./pages/modules/bcn-lop-for-lop/bcn-lop-for-lop.module').then(m => m.BcnLopForLopModule),
        canActivate: [hasPermissionGuard]
      },           
    ]
  },
  {
    path: '**', component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
